import { useMemo } from 'react';

import { useChainList, UseChainListItem } from './useChainList';

export function useUnitChainData(chainUnit: string): UseChainListItem | null {
  const list = useChainList();

  return useMemo(
    () =>
      list.find(
        chainData =>
          chainData.chainUnit.toLowerCase() === chainUnit.toLowerCase(),
      ) ?? null,
    [chainUnit, list],
  );
}
